import React, { useContext } from 'react';
import StoreContext from '../../context/StoreContext';
import { QuantitySelector } from '.';
import { FrameSvg } from '../common';
import { getPrice } from '../../util/helpers';
import './LineItem.scss';

const LineItem = (props) => {
  const { lineItem } = props;
  const context = useContext(StoreContext);
  const {
    id,
    title,
    quantity,
    variant,
  } = lineItem;
  const {
    removeLineItem,
    updateLineItem,
    client,
    checkout,
  } = context;
  const {
    price,
    image,
    selectedOptions,
  } = variant;
  const { currencyCode } = checkout;
  const displayPrice = getPrice(price * quantity, currencyCode);
  const handleRemove = () => {
    removeLineItem(client, checkout.id, id);
  };
  const handleUpdate = (newQty) => {
    updateLineItem(client, checkout.id, id, newQty);
  };
  const increaseQuantity = (event) => {
    event.preventDefault();
    handleUpdate(quantity + 1);
  };
  const decreaseQuantity = (event) => {
    event.preventDefault();
    if (quantity <= 1) {
      handleRemove();
    } else {
      handleUpdate(quantity - 1);
    }
  };
  const variantOptions = selectedOptions.filter(option => option.name !== 'Title');
  return (
    <li className="line-item" key={id} id={id}>
      <div className="cols">
        <div className="col col-left">
          <div className="line-item-image">
            <img src={image.src} alt={`${title} product shot`} />
            <FrameSvg />
          </div>
        </div>
        <div className="col col-middle">
          <div className="line-item-details">
            <span className="line-item-title">{title}</span>
            { variantOptions && variantOptions.length > 0 && (
              <div className="line-item-options">
                <span>(</span>
                <div className="options">
                  { variantOptions.map((option, index) => (
                    <div
                      className="line-item-option"
                    >
                      <span className="option-value">{`${option.value}${index !== variantOptions.length - 1 ? ' / ' : ''}`}</span>
                    </div>
                  ))}
                </div>
                <span>)</span>
              </div>
            )}
          </div>
          <QuantitySelector
            productName={title}
            quantity={quantity}
            decreaseQuantity={decreaseQuantity}
            increaseQuantity={increaseQuantity}
          />
        </div>
        <div className="col col-right">
          <button
            type="button"
            onClick={handleRemove}
            className="remove-line-item-button"
            aria-label={`Remove ${title} from your cart`}
          >
            <div className="icon">
              <svg viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg">
                <g
                  stroke="#E99200"
                  strokeWidth="2"
                  fill="none"
                  fillRule="evenodd"
                  strokeLinecap="round"
                >
                  <path d="M1 1c.591.923 1.682 2.18 3.272 3.77 1.59 1.59 4.17 4.004 7.738 7.24" />
                  <path d="M12.01 1c-.594.534-1.513 1.423-2.759 2.669-.827.828-2.316 2.72-4.472 4.903-.726.735-1.986 1.88-3.779 3.438" />
                </g>
              </svg>
            </div>
          </button>
          <span className="price">{displayPrice}</span>
        </div>
      </div>
    </li>
  );
};

export default LineItem;
